import React, { useEffect, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import * as moment from "moment";
import { getClaimHistory } from "../../actions/admin";
import config from "../.././lib/config";
import { toastAlert } from "../../lib/toastAlert.js";

export default function Table() {
  const [claimData, setClaim] = useState();

  useEffect(() => {
    getAll();
  }, []);

  const getAll = async () => {
    var res = await getClaimHistory();
    // setClaim(res?.result);

    var array = res.result;
    var newarray = [];
    array &&
      array.length > 0 &&
      array.map((items) => {
        newarray.push({
          Address: items.address,
          Amount: items.amount,
          Hash: items.hash,
          Date: moment(items.createdAt).format("MMMM,Do YYYY, hh:mm A"),
        });
        return newarray;
      });

    setClaim(newarray);
  };

  const halfAddrShow = (addr) => {
    if (addr) {
      return addr.substring(0, 10) + "...." + addr.slice(addr.length - 5);
    } else {
      return "";
    }
  };
  async function CopyFunction(text) {
    navigator.clipboard.writeText(text);
    toastAlert("success", "Copied!");
  }

  const columns = [
    {
      name: "Sno",
      sortable: true,
      cell: (row, index) => <div data-tag="allowRowEvents">{index + 1}</div>,
    },
    {
      name: "Address",
      sortable: true,
      cell: (row) => (
        <a
          style={{ cursor: "pointer" }}
          onClick={() => CopyFunction(row.Address)}
        >
          {halfAddrShow(row.Address)}
        </a>
      ),
    },
    {
      name: "Amount",
      sortable: true,
      cell: (row) => <div data-tag="allowRowEvents">{row.Amount}</div>,
    },
    {
      name: "Hash",
      sortable: true,
      cell: (row) => (
        <a href={`${config.HashLink}${row.Hash}`} target="_blank">
          {halfAddrShow(row.Hash)}
        </a>
      ),
    },
    {
      name: "Date",
      sortable: true,
      cell: (row) => <div data-tag="allowRowEvents">{row.Date}</div>,
    },
  ];

  function convertArrayOfObjectsToCSV(array) {
    let result;

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = Object.keys(claimData[0]);

    result = "";
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];

        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  function downloadCSV(array) {
    const link = document.createElement("a");
    let csv = convertArrayOfObjectsToCSV(array);
    if (csv == null) return;

    const filename = "ClaimHistory.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }

  return (
    <div>
      <h3>Claim History</h3>
      {claimData && claimData.length > 0 ? (
        <>
          {" "}
          <button
            class="btn btn-primary"
            onClick={() => downloadCSV(claimData)}
          >
            Export CSV
          </button>
        </>
      ) : (
        ""
      )}

      <DataTable
        columns={columns}
        data={claimData}
        noHeader
        pagination={true}
        paginationPerPage="10"
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
      />
    </div>
  );
}
